const UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

/**
 * Human-readable byte counts, shared so every surface that shows a file size agrees.
 *
 * There were three separate implementations of this before (the asset review panel, the download
 * panel, and an inline MB-only expression), which is how the upload dialogs ended up quoting a
 * number nobody could trace back to the server (ORB-721).
 */
export function formatBytes(bytes: number): string {
  // A count that cannot be rendered honestly is said to be unknown rather than shown as "0 B".
  // Zero is a real, different statement — an empty file — and this helper now backs the dialog that
  // states the upload maximum, so a wrong number there is worse than no number.
  if (typeof bytes !== 'number' || !Number.isFinite(bytes) || bytes < 0) return 'Unknown'
  if (bytes === 0) return '0 B'

  const k = 1024
  // Clamped at BOTH ends. Past the last unit the index runs off the end; below one byte the log goes
  // negative and it runs off the front. Either way the rendered string contains "undefined".
  const exponent = Math.min(Math.max(Math.floor(Math.log(bytes) / Math.log(k)), 0), UNITS.length - 1)
  return `${parseFloat((bytes / Math.pow(k, exponent)).toFixed(1))} ${UNITS[exponent]}`
}
